import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { HomeOutlined } from '@ant-design/icons';

// DS
import {
  Col,
  VertTypography,
  VertIcon,
  VertModal,
  VertButton,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/ModalNewDeliveryAddressStyles.less';

// UTILS
import FormsDeliveryAddress from 'components/Forms/FormsDeliveryAddress';

// MODAL NEW DELIVERY ADDRESS COMPONENT
const ModalNewDeliveryAddress = ({ ...props }) => {
  const { address, open, onStateModal } = props;

  const [newAddress, setNewAddress] = useState({ ...address });
  const openModalHandle = () => {
    onStateModal(!open);
  };
  const onChangeAddress = ({ target, value }) => {
    setNewAddress({ [target]: value, ...newAddress });
  };

  const afterClose = () => {
    setNewAddress({
      contact: '',
      name: '',
      street: '',
      number: '',
      bourgh: '',
      city: '',
      state: '',
      uf: '',
      cep: '',
      complement: '',
      reference: '',
    });
    openModalHandle();
  };

  return (
    <VertModal
      open={open}
      className="modal-new-delivery-address"
      onCancel={openModalHandle}
      afterClose={afterClose}
      width={960}
      title={(
        <>
          <Col className="modal-new-delivery-address-title">
            <VertIcon component={HomeOutlined} />
            <VertTypography.Title>Endereço de entrega</VertTypography.Title>
          </Col>
          <hr className="divider" />
        </>
      )}
    >
      <div className="modal-new-delivery-address-content">
        <VertTypography.Paragraph className="subtittle">
          Todos os campos são de preenchimento obrigatório.
        </VertTypography.Paragraph>
        <FormsDeliveryAddress
          data={address}
          isValid={(event) => console.log(event)}
          onChange={(event) => onChangeAddress(event)}
        />
        <Col className="modal-new-delivery-address-footer">
          <VertButton
            className="save-addres-button"
            type="default"
            onClick={() => console.log('save')}
            // spacing="large"
          >
            Salvar Endereço
          </VertButton>
        </Col>
      </div>
    </VertModal>
  );
};

ModalNewDeliveryAddress.propTypes = {
  address: PropTypes.shape({
    contact: PropTypes.string,
    name: PropTypes.string,
    street: PropTypes.string,
    number: PropTypes.number,
    bourgh: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    uf: PropTypes.string,
    cep: PropTypes.string,
    complement: PropTypes.string,
    reference: PropTypes.string,
  }),
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onStateModal: PropTypes.func,
};

export default ModalNewDeliveryAddress;
